const PORTAL_LOGIN_PATH = '/portal-login';

function normalizeOrigin(origin: string): string {
  return origin.trim().replace(/\/+$/, '');
}

/** Live deploy origin override (VentraIP / production). Falls back to current browser origin. */
export function resolveAppOrigin(): string {
  const configured = import.meta.env.VITE_PUBLIC_APP_ORIGIN?.trim();
  if (configured) {
    return normalizeOrigin(configured);
  }

  if (typeof window !== 'undefined' && window.location?.origin) {
    return window.location.origin;
  }

  return '';
}

/** QR codes and mobile access links always target the live portal login route. */
export function resolvePortalAccessUrl(): string {
  const origin = resolveAppOrigin();
  return `${origin}${PORTAL_LOGIN_PATH}`;
}
